import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBuilding = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.785 2.02305C12.0433 1.96429 12.3015 2.02305 12.5311 2.14056C15.4867 3.75635 18.471 5.37213 21.4266 6.95854C21.7709 7.16419 21.9718 7.5461 22.0005 7.95739C21.9718 8.28055 21.8283 8.60371 21.5701 8.80935C21.3692 8.95624 21.1396 9.04437 20.9101 9.04437H3.09041C2.80346 9.04437 2.51651 8.92686 2.31565 8.72122C2.11478 8.51557 2 8.22179 2 7.92801C2 7.51672 2.22956 7.13481 2.5739 6.95854C5.5295 5.37213 8.4851 3.75635 11.4407 2.16994C11.5268 2.11118 11.6416 2.05243 11.785 2.02305ZM11.9859 4.37328C10.4364 5.19587 8.88683 6.01845 7.36599 6.84103H16.6345C15.1137 6.01845 13.5641 5.19587 12.0433 4.34391C12.0146 4.34391 11.9859 4.34391 11.9859 4.37328Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.9556 9.80816H6.07471C6.39035 9.80816 6.6773 10.1313 6.6773 10.4545V18.4159C6.6773 18.739 6.39035 19.0328 6.07471 19.0622H5.01299C4.78343 19.0622 4.55386 18.9153 4.46778 18.7097C4.41039 18.6215 4.38169 18.504 4.38169 18.3865V10.4251C4.353 10.1313 4.63995 9.83754 4.9556 9.80816Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4981 9.80816H12.6172C12.9328 9.80816 13.2198 10.1313 13.2198 10.4545V18.3571C13.2198 18.504 13.1911 18.6215 13.1337 18.739C13.0189 18.9447 12.8181 19.0622 12.5885 19.0622H11.5268C11.2111 19.0622 10.9242 18.7684 10.9242 18.4159V10.4251C10.9242 10.1313 11.1824 9.83754 11.4981 9.80816Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0693 9.80816H18.9875C19.1023 9.80816 19.2171 9.80816 19.3318 9.83754C19.5901 9.92567 19.791 10.1901 19.791 10.4545V18.4159C19.791 18.6803 19.6188 18.9153 19.3892 19.0035C19.2458 19.0622 19.1023 19.0622 18.9588 19.0622H18.098C17.8397 19.0622 17.6101 18.8859 17.5241 18.6803C17.4667 18.5628 17.4667 18.4159 17.4667 18.269V10.4545C17.4667 10.1313 17.7536 9.83754 18.0693 9.80816Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.46345 19.7967C3.57823 19.7673 3.72171 19.7673 3.83649 19.7673H20.4223C20.6805 19.7673 20.9675 19.8848 21.1396 20.0611C21.3692 20.2667 21.484 20.5605 21.484 20.8836C21.484 21.2362 21.3118 21.5593 21.0536 21.765C20.824 21.9412 20.537 22 20.2501 22H3.95127C3.7791 22 3.63562 22 3.46345 21.9706C3.11911 21.9119 2.83216 21.6768 2.68868 21.3537C2.54521 21.0305 2.54521 20.6486 2.71738 20.3548C2.88955 20.0611 3.1478 19.8554 3.46345 19.7967Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconBuilding;
